import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export const FloatingCart = () => {
  const { totalCount, totalAmount, openCart } = useCart();

  return (
    <AnimatePresence>
      {totalCount > 0 && (
        <motion.button
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          onClick={openCart}
          data-testid="floating-cart-btn"
          aria-label="Ver carrito"
          className="fixed bottom-5 left-1/2 -translate-x-1/2 sm:left-auto sm:right-6 sm:translate-x-0 z-50 w-[92%] sm:w-auto flex items-center justify-between gap-4 bg-brand-burgundy text-brand-cream font-bold pl-5 pr-4 py-4 rounded-full shadow-2xl shadow-black/40 hover:bg-brand-red transition-colors"
        >
          <span className="flex items-center gap-3">
            <span className="relative">
              <ShoppingBag className="w-6 h-6 text-brand-gold" />
              <span className="absolute -top-2 -right-2 bg-brand-gold text-brand-base text-[11px] font-black w-5 h-5 rounded-full flex items-center justify-center">
                {totalCount}
              </span>
            </span>
            <span className="uppercase tracking-widest text-sm">Ver pedido</span>
          </span>
          <span className="font-display text-lg">${totalAmount}</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
